import Loadable from '../../components/loadable';

const ContactMessageSender = Loadable({
  loader: () => import('../../pages/messages/contact_message_sender'),
  type: 'drawer',
});

angular.module('shared').value('ContactMessageSender', ContactMessageSender);
